import React from 'react';
import './Button.scss';

function Button(props) {
    return (
        <button
            onClick={props?.onClick}
            style={{
                background: props?.variant === 'dark' ? '#252525' : '#00AFCF',
                borderRadius: props?.borderRadius ?? '8px',
                padding: props.padding ?? '14px 28px',
                width: props?.width ?? 'max-content',
                color: props?.color ?? 'white',
                fontSize: '16px',
                fontWeight: '600',
                textAlign: 'center',
                margin: props?.margin ?? '0',
                outline: 'none',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0, 175, 207, 0.2)',
            }}
            onMouseEnter={(e) => {
                if (props?.variant !== 'dark') {
                    e.target.style.background = '#0099b8';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 175, 207, 0.3)';
                    e.target.style.transform = 'translateY(-1px)';
                } else {
                    e.target.style.background = '#1a1a1a';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
                    e.target.style.transform = 'translateY(-1px)';
                }
            }}
            onMouseLeave={(e) => {
                if (props?.variant !== 'dark') {
                    e.target.style.background = '#00AFCF';
                    e.target.style.boxShadow = '0 2px 8px rgba(0, 175, 207, 0.2)';
                    e.target.style.transform = 'translateY(0)';
                } else {
                    e.target.style.background = '#252525';
                    e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                    e.target.style.transform = 'translateY(0)';
                }
            }}
        >
            {props?.children}
        </button>
    );
}

export default Button;
